import { Alert, Box } from "@mui/material";
import { Typography } from "@avenue-8/sidekick-ui";
import { useOtherAppLogoAsset } from "@shared/hooks/useAppLogoAsset";

type Props = {
  otherAppName: string;
  url: string;
};

export const WrongBrandDialogContent = ({ otherAppName, url }: Props) => {
  const {
    src: logoSrc,
    alt: logoAlt,
    height: logoHeight,
  } = useOtherAppLogoAsset("blue", "xl");
  const { origin } = new URL(url);
  const host = origin.replace(/^https?:\/\//, "");

  return (
    <>
      <Typography>
        Sidekick and Radar are now separate apps, each with its own address.
      </Typography>
      <Box display="flex" justifyContent="center" my={3}>
        <img src={logoSrc} alt={logoAlt} style={{ height: logoHeight }} />
      </Box>
      <Alert severity="info" icon={false}>
        <Typography sx={{ display: "block" }}>
          This account belongs on {otherAppName}
        </Typography>
        <Typography sx={{ display: "block", fontWeight: 700, my: 1 }}>
          {host}
        </Typography>
        <Typography sx={{ display: "block" }}>
          Continuing will open a new tab and <strong>sign you out here</strong>{" "}
          — you&apos;ll need to <strong>sign back in</strong> with the right
          account.
        </Typography>
      </Alert>
    </>
  );
};
